module.exports = __webpack_public_path__ + "static/media/bootstrap-4.ffded238.svg";